


























































import Vue from "vue";
import store from "@/store";

// Interface
import { dialogOptions } from "@/interfaces/dialog.interface";
import { NewExericse, Exercise } from "@/interfaces/exercise.interface";

export default Vue.extend({
  props: {
    createExerciseDialog: Boolean,
  },
  data: () => ({
    newExercise: Object() as Exercise,
    overlayLoader: false,
    allBodyParts: [
      "Full Body",
      "Cardio",
      "Olympic",
      "None",
      "Other",
      "Shoulders",
      "Legs",
      "Quads",
      "Hamstrings",
      "Glutes",
      "Calves",
      "Chest",
      "Back",
      "Biceps",
      "Triceps",
      "Core",
    ],
    typsOfExercises: [
      "Barbell",
      "Dumbbell",
      "Machine",
      "Weighted Bodyweight",
      "Assisted Bodyweight",
    ],
  }),
  methods: {
    async createExercise() {
      if (!this.newExercise.exerciseName) {
        alert("Enter Exercise Name");
      } else if (!this.newExercise.type) {
        alert("Enter Exercise Type");
      } else {
        this.overlayLoader = true;

        let newExercise: Exercise = {
          bodyParts: this.newExercise.bodyParts,
          exerciseName: this.newExercise.exerciseName,
          type: this.newExercise.type,
          sets: [],
          showExercise: true,
          exerciseNote: "",
          wantExerciseNote: false,
        };

        let newExerciseLessData: NewExericse = {
          exerciseName: newExercise.exerciseName,
          type: newExercise.type,
          bodyParts: newExercise.bodyParts,
          isCustomExercise: true,
        };

        await store
          .dispatch("exerciseStore/addUserExercise", newExerciseLessData)
          .then(() => {
            this.overlayLoader = false;
            this.newExercise = Object() as Exercise;
            this.dialogController("closeAll");
          })
          .catch(() => {
            this.overlayLoader = false;
            alert("There was a problem creating your exercise");
          });
      }
    },
    dialogController(dialogToBeOpen: dialogOptions) {
      this.newExercise = Object() as Exercise;
      this.$emit("dialogController", dialogToBeOpen);
    },
  },
});
